import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgData = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M20.438 1.308H4.724a.785.785 0 0 0-.786.785v20.429c0 .435.351.786.786.786h15.714a.785.785 0 0 0 .786-.786V2.093a.785.785 0 0 0-.786-.785ZM5.706 3.076h13.75v5.107H5.706V3.076Zm13.75 11.785H5.706V9.754h13.75v5.107Zm0 6.679H5.706v-5.107h13.75v5.107ZM7.474 5.63a.982.982 0 1 0 1.964 0 .982.982 0 0 0-1.964 0Zm0 6.678a.982.982 0 1 0 1.964 0 .982.982 0 0 0-1.964 0Zm0 6.678a.982.982 0 1 0 1.964 0 .982.982 0 0 0-1.964 0Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgData)
const Memo = memo(ForwardRef)
export default Memo
